/**
 * Google Keep Chrome Extension
 *
 * Exposes 86 static resources to every origin, including its main UI page.
 * Manifest verified against version 4.26281.540.1.
 */
import { probeFetch } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';
const ID = 'lpcaedmchfhocbbapmcbpinfpgnhiddi';
export const googleKeep: ExtensionDefinition = {
  id: ID,
  name: 'Google Keep Chrome Extension',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 6_000_000,
  signals: [
    { id: 'war-index-html', kind: 'web-accessible-resource',
      description: 'Fetch index.html — the note-taking popup UI, exposed to <all_urls>.',
      weight: 1, run: () => probeFetch(ID, 'index.html') },
    { id: 'war-i18n-symbols', kind: 'web-accessible-resource',
      description: 'Fetch i18n/symbols_en.js — a bundled locale table, stable across releases.',
      weight: 0.5, run: () => probeFetch(ID, 'i18n/symbols_en.js') },
  ],
};
